import React, { useEffect, useMemo, useState } from "react";
import "./AccountAnalysis.scss";
import {
  Link,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Tabination from "../../reusableComponents/Tabs";
import LongShortBal from "../../components/Analysis/LongShortBal/LongShortBal";
import ResultsByDay from "../../components/Analysis/ResultsByDay/ResultsByDay";
import LongShortComp from "../../components/Analysis/LongShortComp/LongShortComp";
import TradingDaysAnalysis from "../../components/Analysis/TradingDaysAnalysis/TradingDaysAnalysis";
import ResultPositionSize from "../../components/Analysis/ResultPositionSize/ResultPositionSize";
import ResultTradeDuration from "../../components/Analysis/ResultTradeDuration/ResultTradeDuration";
import ResultOpenHour from "../../components/Analysis/ResultOpenHour/ResultOpenHour";
import TradeHistory from "../../components/Analysis/TradeHistory/TradeHistory";
import BackButton from "../../reusableComponents/BackButton/BackButton";
import AccountMetricsHeader from "../../components/AccountMetricsHeader";
import { getAccountStats } from "../../utils/apis/accountsApi";
import { useDispatch, useSelector } from "react-redux";
import LoaderOverlay from "../../reusableComponents/LoaderOverlay/Index";
import { returnErrors } from "../../utils/store/reducers/Error";

const AccountAnalysis = () => {
  const [activeTab, setActiveTab] = useState();
  const [analysisData, setAnalysisData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { idToken } = useSelector((state) => state?.auth);
  const { login_id } = useSelector((state) => state?.accountList);
  const { data, error } = useSelector((state) => state?.accountMetrics);

  const dispatch = useDispatch();

  console.log("analysisData", analysisData, data);

  const resetAccount = (loginId) => {
    // Handle reset account functionality
    console.log("Reset account:", loginId);
  };

  useEffect(() => {
    error && dispatch(returnErrors(error, 400));
  }, [error]);

  // end

  const items = [
    {
      name: "Trade Calendar",
      path: "trade-calendar",
    },

    {
      name: "Long/Short Balance",
      path: "long-short-balance",
    },
    {
      name: "Results by days",
      path: "result-by-days",
    },
    {
      name: "Long / Short Comparison",
      path: "long-short-comparison",
    },
    {
      name: "Trading days Analysis",
      path: "trading-days-analysis",
    },
    {
      name: "Results by Position size",
      path: "results-by-position-size",
    },
    {
      name: "Results by Trade Duration",
      path: "results-by-trade-duration",
    },
    {
      name: "Results by Open Hour",
      path: "results-by-open-hour",
    },
  ];
  const location_path = useLocation();
  const location = useLocation();
  // Extract the relevant part of the path
  const desiredPart = useMemo(() => {
    const segments = location_path.pathname.split("/");
    return segments[2]; // Adjust if needed based on route structure
  }, [location_path.pathname]);

  useEffect(() => {
    const currentLocation = desiredPart ? "/" + desiredPart : "";

    // Find the index of the item matching the path
    const activeIndex = items.findIndex((item) => item.path === desiredPart);

    // Update state only if a valid index is found
    if (activeIndex !== -1) {
      setActiveTab(activeIndex);
    }
  }, [desiredPart]);

  useEffect(() => {
    const fetchAccountStatsData = async () => {
      if (!idToken) return;
      setLoading(true);
      setAnalysisData(null); // Clear previous data before fetching new
      try {
        const response = await getAccountStats(idToken, login_id);
        setAnalysisData(response?.data);

        if (response?.data) {
          setAnalysisData(response?.data);
        } else {
          console.warn("No account analysis data found");
        }
      } catch (error) {
        console.error("Error fetching account analysis:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccountStatsData();
  }, [idToken, login_id]);

  const navigate = useNavigate();

  const handleRedirectLink = (path) => {
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path, { replace: true }); // 👈 ensures URL is replaced
    }
  };
  return (
    <div className="AcctAnalysisMain">
      {loading && <LoaderOverlay />}

      <AccountMetricsHeader onResetAccount={resetAccount} />

      <div className="header_two">
        <BackButton onClick={() => handleRedirectLink("/account-stats")} />
        <Tabination
          variant={1}
          tabItems={items}
          showTabs={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          mainurl={"/account-analysis/"}
        />
      </div>

      <div className="affiliate-page">
        <Routes>
          <Route
            path="/"
            element={<Navigate to="trade-calendar" replace={true} />}
          />
          <Route
            path="/long-short-balance"
            element={
              <LongShortBal
                long_short_comp={analysisData?.account_data_analysis}
              />
            }
          />
          <Route
            path="/result-by-days"
            element={
              <ResultsByDay
                data={
                  analysisData?.account_data_analysis?.day_wise_data || null
                }
              />
            }
          />
          <Route
            path="/long-short-comparison"
            element={
              <LongShortComp
                data={
                  analysisData?.account_data_analysis?.result_by_instruments ||
                  null
                }
              />
            }
          />
          <Route
            path="/trading-days-analysis"
            element={
              <TradingDaysAnalysis
                trading_days_analysis={
                  analysisData?.account_data_analysis || null
                }
              />
            }
          />
          <Route
            path="/results-by-position-size"
            element={
              <ResultPositionSize
                data={
                  analysisData?.account_data_analysis?.results_by_lots || null
                }
              />
            }
          />
          <Route
            path="/results-by-trade-duration"
            element={
              <ResultTradeDuration
                result_by_trade_duration={analysisData}
                loading={loading}
              />
            }
          />
          <Route path="/trade-calendar" element={<TradeHistory />} />
          <Route
            path="/results-by-open-hour"
            element={
              <ResultOpenHour
                result_by_open_hour={analysisData}
                loading={loading}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default AccountAnalysis;
